import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { IPaymentList } from '@modules/private/payment/data/interfaces/ipayment.interface';
import { IResponseArray } from '@data/interfaces/iresponseArray.interface';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiPaymentService extends ApiClass {
  id!: string

  constructor() {
    super()
    this.path = 'payments'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    const response: IPaymentList = {
      error: true,
      msg: '',
      data: [],
      total: 0,
      status: 200,
      page: 1,
      itemsByPage: 10,
      totalItems: 0
    }

    //* El alcance del cliente se AÑADE a lo que la tabla pida, no lo sustituye: sobrescribir el
    //* objeto entero tiraba en silencio los filtros de columna que escribiera el usuario.
    const conAlcance = { ...filters, client: { value: this.id, matchMode: 'equals' } }

    //! El `populate` lo manda el CLIENTE en el cuerpo (`FiltersDto.populate`): el endpoint no puebla
    //! nada por su cuenta. Sin esto, `client`, `account` y `user` llegan como referencias en crudo y
    //! la tabla —que lee `client.name`, `account.clabe`, `user.names`— pinta «N/A» en las tres.
    //! Es el mismo trío que manda el servicio grande de Pagos; este es una copia reducida
    //! (ver `docs/architecture/modules/customer.md`) y se le había quedado fuera.
    const populate = [{ path: 'account' }, { path: 'user', select: ['names'] }, { path: 'client', select: ['name'] }]

    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters: conAlcance, populate }).pipe(
      map((r) => {
        if (!r || !r.data.data || r.data.data.length === 0) return response;
        return r as IPaymentList;
      }),
      catchError((e) => of(response))
    )
  }
}
